module.exports = __webpack_public_path__ + "img/1904.f54d19e7.png";